import { useEffect, type RefObject } from 'react';
import { useLocation } from 'react-router-dom';

function scrollToTop(container: HTMLElement | null) {
  container?.scrollTo(0, 0);
  document.querySelector('body')?.scrollTo(0, 0);
  window.scrollTo(0, 0);
}

/** Resets the flow's scroll pane when the step changes, including back and side trips. */
export function useScrollToTopOnNavigate(containerRef: RefObject<HTMLElement | null>) {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop(containerRef.current);
  }, [pathname, containerRef]);
}
